import { ReactNode } from "react";
import failImage from "./images/check-fail.svg";
import passImage from "./images/check-pass.svg";
import styles from "./PassFailRow.module.css";
import Typography from "@mui/material/Typography/Typography";
import { useTranslation } from "react-i18next";
import i18nPackage from "../../i18n/i18n";

export type RenderValidationProps = {
	valid?: boolean;
	text?: ReactNode;
};

export default function CorePassFailRow({ valid, text }: RenderValidationProps) {
	const { t } = useTranslation(undefined, { keyPrefix: "coreComponents.passFailRow", i18n: i18nPackage });
	return (
		<span className={styles.validation}>
			<img className={styles.validationImage} src={valid ? passImage : failImage} alt={valid ? t("pass") : t("fail")} />
			<Typography fontSize="14px">{text}</Typography>
		</span>
	);
}
